__turbopack_context__.v({
  "className": "inter_22da4d9f-module__6R6V8G__className",
});
